import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function ServiceCard({ service, index = 0, withImage = false }) {
  const Icon = service.icon;
  return (
    <Reveal delay={(index % 4) * 0.08} className="h-full">
      <div
        data-testid={`service-card-${service.id}`}
        className="spotlight-card group flex h-full flex-col border border-[#262A35] bg-[#121418] transition-colors duration-300 hover:border-[#3B82F6]/60"
      >
        {withImage && (
          <div className="relative h-44 overflow-hidden">
            <img
              src={service.image}
              alt={service.title}
              loading="lazy"
              className="h-full w-full object-cover opacity-70 transition-transform duration-700 ease-out group-hover:scale-105 group-hover:opacity-90"
              style={service.imgPos ? { objectPosition: service.imgPos } : undefined}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#121418] via-transparent to-transparent" />
            <span className="font-mono2 absolute left-4 top-4 bg-[#3B82F6] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-white">
              {service.badge}
            </span>
          </div>
        )}
        <div className="flex flex-1 flex-col p-6">
          <div className="flex items-start justify-between">
            <span className="flex h-11 w-11 items-center justify-center border border-[#3A3F50] bg-[#0B0C0E] transition-colors group-hover:border-[#3B82F6]">
              <Icon className="h-5 w-5 text-[#3B82F6]" strokeWidth={1.8} />
            </span>
            {!withImage && (
              <span className="font-mono2 border border-[#3A3F50] px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-gray-400">
                {service.badge}
              </span>
            )}
          </div>
          <p className="font-mono2 mt-5 text-[10px] uppercase tracking-[0.25em] text-gray-500">
            {service.category}
          </p>
          <h3 className="font-display mt-1.5 text-lg font-bold text-white sm:text-xl">{service.title}</h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-gray-400">{service.description}</p>
          <Link
            to={`/contact?service=${service.id}`}
            data-testid={`service-book-${service.id}`}
            className="font-mono2 mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#3B82F6] transition-colors hover:text-white"
          >
            Book This Service
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </Reveal>
  );
}
